import React from "react";

export const ArrowIcon: React.FC = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 32 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.4032 2.66357L29.0435 13.2239M29.0435 13.2239L20.4032 23.7842M29.0435 13.2239L2.31299 13.2239"
      stroke="currentColor"
      strokeWidth="3.50841"
      strokeLinecap="round"
    />
  </svg>
);
